<template>
  <page-view class="page-contract-search mwclg-style Out">
    <div slot="pageRight">
      <div class="order-list">
        <p class="title">{{ $t('Feedback.FeedbackList') }}</p>
        <el-button
          type="primary"
          size="mini"
          @click="showAddDialog"
          icon="el-icon-plus"
          >{{ $t('Feedback.NewFeedback') }}</el-button
        >
        <div class="table_content">
          <el-table
            v-loading="loading"
            :data="feedbackList"
            stripe
            style="width: 100%"
          >
            <el-table-column
              prop="anticipationType"
              :label="$t('Feedback.FeedbackType')"
            >
              <template slot-scope="scope">
                <span>{{ OPTION_TYPE_OBJ[scope.row.anticipationType] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="anticipationProblem"
              width="800"
              :show-overflow-tooltip="true"
              :label="$t('Feedback.SuggestedContent')"
            >
            </el-table-column>
            <el-table-column
              prop="createDt"
              :label="$t('Feedback.SubmissionDate')"
            >
            </el-table-column>
          </el-table>
        </div>
        <el-dialog
          :title="$t('Feedback.NewFeedback')"
          :visible.sync="dialogFormVisible"
        >
          <el-form
            :model="addForm"
            label-position="top"
            ref="addForm"
            :rules="rules"
          >
            <el-form-item
              :label="$t('Feedback.FeedbackType')"
              prop="anticipationType"
            >
              <el-select
                v-model="addForm.anticipationType"
                size="small"
                :placeholder="$t('InvoiceInquiry.PleaseSelect')"
              >
                <el-option
                  v-for="item in Object.values(OPTION_TYPE)"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('Feedback.SuggestedContent')"
              prop="anticipationProblem"
            >
              <el-input
                v-model="addForm.anticipationProblem"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">{{
              $t('ServiceEvaluation.Cancel')
            }}</el-button>
            <el-button type="primary" @click="add">{{
              $t('ServiceEvaluation.Confirm')
            }}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </page-view>
</template>
<script>
import { PageView } from "@/components";
import { getAnticipation, addAnticipation } from "@/api/feedback";
import i18n from "@/i18n/i18n";
export default {
  name: "InvoiceSearch",
  components: { PageView },
  data() {
    return {
      OPTION_TYPE: [
        {
          name: i18n.t("Feedback.BusinessCategory"),
          id: 0,
          value: i18n.t("Feedback.BusinessCategory"),
        },
        {
          name: i18n.t("Feedback.ServiceCategory"),
          id: 1,
          value: i18n.t("Feedback.ServiceCategory"),
        },
        {
          name: i18n.t("Feedback.SecurityCategory"),
          id: 2,
          value: i18n.t("Feedback.SecurityCategory"),
        },
        {
          name: i18n.t("Feedback.OtherCategories"),
          id: 3,
          value: i18n.t("Feedback.OtherCategories"),
        },
      ],
      OPTION_TYPE_OBJ: {
        0: i18n.t("Feedback.BusinessCategory"),
        1: i18n.t("Feedback.ServiceCategory"),
        2: i18n.t("Feedback.SecurityCategory"),
        3: i18n.t("Feedback.OtherCategories"),
      },
      dialogFormVisible: false,
      addForm: {
        anticipationType: "",
        anticipationProblem: "",
      },
      rules: {
        anticipationType: [
          {
            required: true,
            message: i18n.t("InvoiceInquiry.PleaseSelect"),
            trigger: "blur",
          },
        ],
        anticipationProblem: [
          {
            required: true,
            message: i18n.t("InvoiceInquiry.PleaseEnter"),
            trigger: "blur",
          },
        ],
      },
      loading: false,
      feedbackList: [],
    };
  },
  created() {
    this.search();
  },
  methods: {
    async search() {
      this.loading = true;
      const { data } = await getAnticipation();
      this.loading = false;
      this.feedbackList = data;
    },
    reset() { },
    async add() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          await addAnticipation(this.addForm);
          this.dialogFormVisible = false;
          this.loading = true;
          this.search();
        }
      });
    },
    showAddDialog() {
      this.addForm = {
        anticipationType: "",
        anticipationProblem: "",
      };
      this.$nextTick(() => {
        this.$refs.addForm.resetFields();
      });
      this.dialogFormVisible = true;
    },
    // search () {
    //   const userInfo = this.$ls.get(USER_INFO)
    //   this.queryParams.CustomerId = userInfo.CACode
    //   this.loading = true
    //   GetARByCusID(this.queryParams).then(res => {
    //     this.dataList = res.Data.CbList || []
    //     this.loading = false
    //   }).catch(() => {
    //     this.loading = false
    //   })
    // },
    // reset () {
    //   this.queryParams = {}
    //   this.search()
    // }
  },
};
</script>
<style lang="less">
.page-contract-search {
  padding: 10px;
  background: #f0f6fb;
  // .plr25 {
  //   padding-left: 0px !important;
  //   padding-right: 0px !important;
  // }
  // .ptb25 {
  //   padding-top: 0px !important;
  //   padding-bottom: 0px !important;
  // }
  .order-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
  }
  .order-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
    // min-height:60vh;
    .list-item {
      margin-bottom: 8px;
    }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .table_content {
    margin-top: 20px;
  }
}
.Out .el-textarea textarea {
  min-height: 100px !important;
}
</style>
<style>
.el-loading-mask {
  z-index: 1000;
}
</style>
